module.exports = __webpack_public_path__ + "static/img/lineup_bg_j_peach.8b482bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_bg_j_peach.jpg
// module id = KCij
// module chunks = 1